import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['lesson', 'checkbox', 'videoLesson', 'worksheetLesson', 'alphabetGroup', 'lessonTypeFilterButton']

  filterLessons () {
    let lessonTargets = []

    // Hide all lessons first
    this.lessonTargets.forEach(lesson => lesson.classList.add('d-none'))

    // Filter lessons by type
    lessonTargets = this.filterByLessonType();

    // Filter lessons by selected courses
    lessonTargets = this.filterByCourse(lessonTargets)

    // Show only filtered lessons
    lessonTargets.forEach(lesson => lesson.classList.remove('d-none'))

    // If any alphabet group is completely empty, hide the group title
    this.alphabetGroupTargets.forEach(group => this.hideAlphabetGroups(group))
  }

  toggleLessonTypeFilter (event) {
    if (event.currentTarget.classList.contains('active')) { // Deactivate selected lesson type to show all lessons
      event.currentTarget.classList.remove('active')
    } else { // Activate lesson type filter and show relevant lessons
      this.lessonTypeFilterButtonTargets.forEach(button => button.classList.remove('active'))
      event.currentTarget.classList.add('active')
    }
    this.filterLessons()
  }

  filterByCourse(lessonTargets) {
    // Filter by selected courses
    const checkedCourseIds = Array.from(this.checkboxTargets)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);
      
    if (checkedCourseIds.length > 0) {
      lessonTargets = lessonTargets.filter(lesson => checkedCourseIds.includes(lesson.dataset.courseId))
    }

    return lessonTargets
  }

  filterByLessonType () {
    const lessonFilter = this.lessonTypeFilterButtonTargets.filter(el => el.classList.contains('active'))[0]
    let lessonTargets = []

    if (lessonFilter) {
      let lessonType = lessonFilter.dataset.lessonType
      lessonTargets = this[`${lessonType}LessonTargets`]
    } else {
      lessonTargets = this.lessonTargets
    }

    return lessonTargets
  }

  hideAlphabetGroups (group) {
    let lessonPills = Array.from(group.querySelectorAll('.lesson-pill')).filter(el => !el.classList.contains('d-none'))

    if (lessonPills.length > 0) {
      group.classList.remove('d-none')
    } else {
      group.classList.add('d-none')
    }
  }
}